import { render, staticRenderFns } from "./listaDocentes.vue?vue&type=template&id=12950e88"
import script from "./listaDocentes.vue?vue&type=script&lang=js"
export * from "./listaDocentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports